<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qrData: {
        AuthNumber: null,
        IssuedTimeStamp: null
      }
    };
  },
  created() {
    const hash = window.location.hash;
    const knownRoutes = ['#/qr-search', '#/manual-search', '#/survey'];
    const isKnownRoute = knownRoutes.some(route => hash.startsWith(route));

    if (isKnownRoute) return;

    if (hash.includes('?')) {
      const urlParams = new URLSearchParams(hash.split('?')[1]);
      const authNumber = urlParams.get('GenerationCode');
      const issuedTimeStamp = urlParams.get('IssuedDateTime');
      if (authNumber && issuedTimeStamp) {
        this.$router.push({ name: 'QRSearch', query: { GenerationCode: authNumber, IssuedDateTime: issuedTimeStamp } });
      } else if(authNumber && issuedTimeStamp == null) {
        this.$router.push({ name: 'Survey', query: { GenerationCode: authNumber }});
      } else {
        this.$router.push({ name: 'Busqueda Manual' });
      }
    } else {
      this.$router.push({ name: 'Busqueda Manual' });
    }
  },
  methods: {
    disableRTL() {
      if (!this.$rtl.isRTL) {
        this.$rtl.disableRTL();
      }
    },
    toggleNavOpen() {
      let root = document.getElementsByTagName('html')[0];
      root.classList.toggle('nav-open');
    }
  },
  mounted() {
    this.$watch('$route', this.disableRTL, { immediate: true });
    this.$watch('$sidebar.showSidebar', this.toggleNavOpen);
    let docClasses = document.body.classList;
    docClasses.add('white-content');
  }
};
</script>

<style lang="scss"></style>
